import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthentificationService } from '../services/authentification.service';

/**
 * Guard d'authentification
 * @implements CanActivate
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    /**
     * Constructeur
     * @param authentificationService
     * @param router
     */
    constructor(@Inject(AuthentificationService) private authentificationService: AuthentificationService, private router: Router)
    {
    }

    /**
     * Gestion de l'authentification
     * @param next
     * @param state
     */
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>
    {
        let obs = this.authentificationService.estConnecte();
        return obs.toPromise().then((estConnecte: boolean) => {
            if (!estConnecte) {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            }

            let role = next.data.role as string;
            if (role) {
                let obsRole = this.authentificationService.possedeRole(role);
                return obsRole.toPromise().then((possedeRole: boolean) => {
                    if (!possedeRole) {
                        this.router.navigate(['/erreur4032'], { queryParams: { returnUrl: state.url } });
                    }

                    return possedeRole;
                });
            }

            return estConnecte;
        });
    }
  
}
